<template>
	<div id="app"><router-view></router-view></div>
</template>

<script>
import MobileDetect from 'mobile-detect';

	export default {
		name: 'app',
		computed: {
			isMobile() {
				return this.$store.getters['device/isMobile']; // 使用 device 模块的 getter
			}
		},
		created() {
			// 初始检测设备类型
			this.$store.dispatch('device/autoDetectByUserAgent');
			this.$store.dispatch('device/updateByWindowSize');
		},
		mounted() {
			
			// 在组件挂载后替换meta标签
			this.replaceMetaTags();
			this.handleResize = () => {
			this.$store.dispatch('device/updateByWindowSize');
			};
			window.addEventListener('resize', this.handleResize);
		},
		beforeDestroy() {
			// 移除监听
			window.removeEventListener('resize', this.handleResize);
		},
		
		methods: {
			replaceMetaTags() {
				// 移除旧的meta标签
				const existingMeta = document.querySelector('meta[name="viewport"]');
				existingMeta.content ='width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no';
			},
			beforeDestroy() {
				const existingMeta = document.querySelector('meta[name="viewport"]');
				existingMeta.content = 'width=device-width, initial-scale=1';
			}
		}

	}
</script>

<style>
#app {
		
	}
</style>